import { DateField } from "@/components/DateField";

const toggle = (list, v) => (list.includes(v) ? list.filter((x) => x !== v) : [...list, v]);

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const PRESETS = [
  ["Mois en cours", () => { const n = new Date(); return [iso(new Date(n.getFullYear(), n.getMonth(), 1)), iso(n)]; }],
  ["Mois dernier", () => { const n = new Date(); return [iso(new Date(n.getFullYear(), n.getMonth() - 1, 1)), iso(new Date(n.getFullYear(), n.getMonth(), 0))]; }],
  ["Trimestre en cours", () => { const n = new Date(); return [iso(new Date(n.getFullYear(), Math.floor(n.getMonth() / 3) * 3, 1)), iso(n)]; }],
  ["3 derniers mois", () => { const n = new Date(); const last = new Date(n.getFullYear(), n.getMonth() - 2, 0).getDate(); return [iso(new Date(n.getFullYear(), n.getMonth() - 3, Math.min(n.getDate(), last))), iso(n)]; }],
];

export const ChipSelect = ({ options, selected, onChange, testid, label = (v) => v || "Non renseigné" }) => (
  <div className="rc-chips" data-testid={testid}>
    {options.map((o) => (
      <button key={o.value} type="button" className={`rc-chip${selected.includes(o.value) ? " on" : ""}`} onClick={() => onChange(toggle(selected, o.value))} data-testid={`${testid}-${o.value || "vide"}`}>
        {label(o.value)} <small>{o.count.toLocaleString("fr-FR")}</small>
      </button>
    ))}
  </div>
);

const Num = ({ value, onChange, placeholder, testid }) => (
  <input type="number" min="0" value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))} data-testid={testid} />
);

const Toggle = ({ checked, onChange, children, testid }) => (
  <label className="rc-toggle"><input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} /> {children}</label>
);

export const RecycleFilters = ({ facets, f, set }) => {
  const up = (patch) => set({ ...f, ...patch });
  return (
    <div className="rc-grid" data-testid="recycle-filters">
      <div className="rc-field">
        <span>Période (date de l'annonce)</span>
        <div className="rc-row">
          <DateField value={f.date_from || ""} min={facets.date_min} max={facets.date_max} onChange={(v) => up({ date_from: v || null })} placeholder="Début" testid="recycle-date-from" />
          <span>→</span>
          <DateField value={f.date_to || ""} min={facets.date_min} max={facets.date_max} onChange={(v) => up({ date_to: v || null })} placeholder="Fin" testid="recycle-date-to" />
        </div>
        <div className="rc-presets">
          {PRESETS.map(([label, fn]) => { const [a, b] = fn(); return <button key={label} type="button" className={`rc-chip${f.date_from === a && f.date_to === b ? " on" : ""}`} onClick={() => up({ date_from: a, date_to: b })} data-testid={`recycle-period-${label.replace(/\W+/g, "-").toLowerCase()}`}>{label}</button>; })}
          {(f.date_from || f.date_to) && <button type="button" className="rc-chip" onClick={() => up({ date_from: null, date_to: null })} data-testid="recycle-period-clear">Toutes dates</button>}
        </div>
        <small>Base du {new Date(facets.date_min).toLocaleDateString("fr-FR")} au {new Date(facets.date_max).toLocaleDateString("fr-FR")}</small>
      </div>
      <div className="rc-field">
        <span>Départements (séparés par des virgules)</span>
        <input value={f.departmentsText || ""} placeholder="ex. 31, 81, 82" onChange={(e) => up({ departmentsText: e.target.value, departments: e.target.value.split(/[\s,;]+/).map((d) => d.trim().padStart(2, "0")).filter((d) => /^\d[\dAB]$/.test(d)) })} data-testid="recycle-departments" />
        <small>Seules les annonces avec un code postal sont filtrables par département.</small>
      </div>
      <div className="rc-field">
        <span>Pièces</span>
        <div className="rc-row"><Num value={f.rooms_min} onChange={(v) => up({ rooms_min: v })} placeholder="min" testid="recycle-rooms-min" /><span>→</span><Num value={f.rooms_max} onChange={(v) => up({ rooms_max: v })} placeholder="max" testid="recycle-rooms-max" /></div>
        <span>Surface (m²)</span>
        <div className="rc-row"><Num value={f.size_min} onChange={(v) => up({ size_min: v })} placeholder="min" testid="recycle-size-min" /><span>→</span><Num value={f.size_max} onChange={(v) => up({ size_max: v })} placeholder="max" testid="recycle-size-max" /></div>
      </div>
      <div className="rc-field rc-wide"><span>Type de bien</span><ChipSelect options={facets.types} selected={f.types} onChange={(v) => up({ types: v })} testid="recycle-types" /></div>
      <div className="rc-field rc-wide"><span>DPE</span><ChipSelect options={facets.energies} selected={f.energies} onChange={(v) => up({ energies: v })} testid="recycle-energies" /></div>
      <div className="rc-field rc-wide"><span>Région (liste d'origine)</span><ChipSelect options={facets.regions} selected={f.regions} onChange={(v) => up({ regions: v })} label={(v) => v.replace(/^Labo2? - /, "")} testid="recycle-regions" /></div>
      <div className="rc-field rc-wide">
        <span>Options</span>
        <div className="rc-row rc-wrap">
          <Toggle checked={f.dedup} onChange={(v) => up({ dedup: v })} testid="recycle-dedup">Un seul exemplaire par numéro</Toggle>
          <Toggle checked={f.exclude_recycled} onChange={(v) => up({ exclude_recycled: v })} testid="recycle-exclude-recycled">Exclure les numéros déjà recyclés par cet outil</Toggle>
          <Toggle checked={f.exclude_converted} onChange={(v) => up({ exclude_converted: v })} testid="recycle-exclude-converted">Exclure les déjà devenus opportunités</Toggle>
          <Toggle checked={f.exclude_disabled} onChange={(v) => up({ exclude_disabled: v })} testid="recycle-exclude-disabled">Exclure les désactivés</Toggle>
        </div>
        <div className="rc-row">
          <select value={f.order} onChange={(e) => up({ order: e.target.value })} data-testid="recycle-order">
            <option value="recent">Plus récentes d'abord</option>
            <option value="oldest">Plus anciennes d'abord</option>
          </select>
          <Num value={f.max_rows} onChange={(v) => up({ max_rows: v || null })} placeholder="Nombre max de lignes (vide = tout)" testid="recycle-max-rows" />
        </div>
      </div>
    </div>
  );
};
